import { render, staticRenderFns } from "./SortingListItem.vue?vue&type=template&id=19e2af0e&"
import script from "./SortingListItem.vue?vue&type=script&lang=js&"
export * from "./SortingListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports